import axios from '../../../utils/axios';
import * as config from 'src/config';
import { portalDomain } from 'src/config';
import { UserMfaStatus } from './userMfaStatus';
import { UserMfaSettings } from './mockData/user-mfa-settings';

const API_PATH_AUTH = {
  ROOT: '/auth',
  SET_MFA: '/set-mfa',
};

/**
 * テスト用Mockデータ
 */
type testMfaSettings = {
  id: string;
  isMfaRequired: boolean; // MFA要否(true:MFA必須)
};

/**
 * 認証API
 */
export const authAPI = {
  /**
   * MFA要否チェック・MFA設定状況取得
   * @param userId ユーザーID
   * @returns MFA設定状況
   */
  async setUserMfaStatus(userId: string): Promise<UserMfaStatus> {
    // ローカル開発時 mockデータを利用する場合
    if (config.currentEnv === 'local' && config.useMockMfaAuth) {
      return this.getTestUserMfaSettings(userId);
    }

    // 対象ユーザーのMFA設定API実行
    const path = `${portalDomain}${API_PATH_AUTH.ROOT}${API_PATH_AUTH.SET_MFA}`;
    const body = {
      id: userId,
    };
    const response = await axios.post(path, body);
    return response.data;
  },

  /**
   * テスト用ユーザーMFA設定取得
   * テストデータから対象ユーザーのIDに合致するMFA認証情報を取得して返す
   * @param userId ユーザーID
   * @returns MFA認証必須設定ありのユーザーの場合: true(=MFA必須), 左記以外の場合: false(MFA不要)
   */
  getTestUserMfaSettings(userId: string): UserMfaStatus {
    // テストデータからログインIDに合致する値があればそれを返す、なければfalseを返す
    try {
      const target = UserMfaSettings.find((m: testMfaSettings) => m.id === userId);
      const isMfaRequired = target?.isMfaRequired ?? false;
      console.log('setUserMfaStatus - return mock data for local test');
      console.log(`isMfaRequired: ${isMfaRequired}`);
      // MFA要否に応じてresponseを返す
      //  - MFA必須ユーザー・UserId不在の場合: 空
      //  - MFA不要ユーザーの場合: MFA不要を設定したresponseObj
      return isMfaRequired
        ? {}
        : {
            isNoNeedMfa: true,
          };
    } catch (error) {
      console.error(error);
      return {};
    }
  },
};
